import {useEffect, useState} from 'react';
import VocaCreateModal from './VocaCreateModal';
import VocaDeleteModal from './VocaDeleteModal';
import onClickFunctionKeys from '../../../utils/pagination';
import VocaTable from './VocaTable';
import ScenarioVocaTable from './ScenarioVocaTable';
import {HiOutlineSearch} from 'react-icons/hi';
import Pagination from '../../common/Pagination';
import {ReactComponent as Plus} from '../../../assets/common/plus-active.svg';
import {ReactComponent as TrashcanActive} from '../../../assets/common/trashcan-active.svg';
import {ReactComponent as Trashcan} from '../../../assets/common/trashcan.svg';
import styles from './styles/voca.module.css';

export default function VocaList({ standardWord, useWord, category, listResponse, pagination, listErrorResponse, listLoading, handleChange }) {
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const [deleteVoca, setDeleteVoca] = useState([]);
    const [localListResponse, setLocalListResponse] = useState([]);
    const [pageNumbers, setPageNumbers] = useState([]);
    const [prevPageNumberLength, setPrevPageNumberLength] = useState(pageNumbers.length);

    const handleChangeDeleteCheckbox = (id) => {
        if (id === 'all') {
            setDeleteVoca(localListResponse.map(item => item.id));
        } else if (id === 'clear') {
            setDeleteVoca([]);
        } else {
            setDeleteVoca(prevState =>
                prevState.includes(id)
                    ? prevState.filter(itemId => itemId !== id)
                    : [...prevState, id]
            );
        }
    };

    const closeModal = () => {
        setIsOpenModal(false);
        handleChange({ target: { name: 'createErrorResponse', value: null } });
        handleChange({ target: { name: 'createResponse', value: null } });
    };

    const closeDeleteModal = () => {
        setLocalListResponse(localListResponse.filter(item => !deleteVoca.includes(item.id)));
        setDeleteVoca([]);
        setIsOpenDeleteModal(false);
        handleChange({ target: { name: 'deleteErrorResponse', value: null } });
        handleChange({ target: { name: 'deleteResponse', value: null } });
    };

    const requestPagination = (page) => {
        handleChange({ target: { name: 'page', value: page } });
    };

    const handleClickPaginationFunctionKeys = (functionKey) => {
        requestPagination(onClickFunctionKeys(functionKey, pageNumbers, pagination.currentPage));
    };

    const initializePagination = () => {
        setPrevPageNumberLength(pageNumbers.length);
        let pages = Array.from({ length: pagination.totalPages }, (_, i) => i + 1);
        setPageNumbers(pages);
    };

    const handleClickCategory = (name) => {
        if (category === name) return;
        setLocalListResponse([]);
        handleChange({ target: { name: 'category', value: name } });
        handleChange({ target: { name: 'useWord', value: '' }});
        handleChange({ target: { name: 'standardWord', value: '' }});
        requestPagination(1);
    };

    useEffect(() => {
        if (!pagination) return;
        initializePagination();
    }, [pagination])

    useEffect(() => {
        if (!listResponse) return;
        setLocalListResponse(listResponse);
    }, [listResponse])

    return (
        <div className={styles.wrapper}>
            <div>
                {/* <div className={styles.contentTypeFilter}>
                    <button className={category === 'WORD' ? `${styles.btnTapInactive} ${styles.btnTapActive}` : `${styles.btnTapInactive}`}
                            onClick={() => handleClickCategory('WORD')}
                    >
                        용어
                    </button>
                    <button className={category === 'SCENARIO' ? `${styles.btnTapInactive} ${styles.btnTapActive}` : `${styles.btnTapInactive}`}
                            onClick={() => handleClickCategory('SCENARIO')}
                    >
                        시나리오
                    </button>
                </div> */}
            </div>
            {isOpenModal && (
                <div className={styles.modalOverlay} onClick={closeModal}>
                    <div className={styles.modalWrapper} onClick={(e) => e.stopPropagation()}>
                        <VocaCreateModal isOpenModal={isOpenModal} setIsOpenModal={closeModal} wordList={localListResponse} category={category} />
                    </div>
                </div>
            )}
            {isOpenDeleteModal && (
                <div className={styles.modalOverlay} onClick={closeDeleteModal}>
                    <div onClick={(e) => e.stopPropagation()}>
                        <VocaDeleteModal isOpenModal={isOpenDeleteModal} setIsOpenModal={closeDeleteModal} deleteVoca={deleteVoca} category={category} />
                    </div>
                </div>
            )}
            <div className={styles.inputContainer}>
                <div className={styles.trashCanIcon} onClick={deleteVoca.length > 0 ? () => setIsOpenDeleteModal(true) : null}>
                    {deleteVoca.length > 0 ? <TrashcanActive /> : <Trashcan />}
                </div>
                <div className={styles.searchWrapper} style={category === 'WORD' ? {width: '27%'} : {width: '43%'}}>
                    <HiOutlineSearch className={styles.searchIcon} />
                    <input className={styles.custom280} style={{width: '100%'}}
                           placeholder={category === 'WORD' ? '표준 단어를 입력하세요' : '시나리오를 입력하세요'}
                           name='standardWord'
                           value={standardWord ? standardWord : ''}
                           onChange={handleChange}
                           autoComplete='off'
                    />
                </div>
                <div className={styles.searchWrapper} style={category === 'WORD' ? {width: '37%'} : {width: '43%'}}>
                    <HiOutlineSearch className={styles.searchIcon} />
                    <input className={styles.custom420} style={{width: '100%'}}
                           placeholder={category === 'WORD' ? '사용 단어를 입력하세요' : '시작 단어를 입력하세요'}
                           name='useWord'
                           value={useWord ? useWord : ''}
                           onChange={handleChange}
                           autoComplete='off'
                    />
                </div>
                <button className={styles.button} onClick={() => setIsOpenModal(true)}>
                    <Plus /> 신규 등록
                </button>
            </div>
            <div className={styles.tableWrapperDiv}>
            {category === 'WORD'
                ? <VocaTable listResponse={localListResponse}
                             listErrorResponse={listErrorResponse}
                             listLoading={listLoading}
                             deleteVoca={deleteVoca}
                             handleChangeDeleteCheckbox={handleChangeDeleteCheckbox}
                             hasFilterParams={!(!useWord && !standardWord)}
                />
                : <ScenarioVocaTable listResponse={localListResponse}
                                     listErrorResponse={listErrorResponse}
                                     listLoading={listLoading}
                                     deleteVoca={deleteVoca}
                                     handleChangeDeleteCheckbox={handleChangeDeleteCheckbox}
                                     hasFilterParams={!(!useWord && !standardWord)}
                />
            }
            </div>
            {pagination && <Pagination prevPageNumberLength={prevPageNumberLength} pageNumbers={pageNumbers} currentPage={pagination.currentPage} handleChangePage={requestPagination} handleClickFunctionKeys={handleClickPaginationFunctionKeys}/>}
        </div>
    );
}
